
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

const PurchaseOrderPDF = {
  generate: async (rowData, logoUrl, companyInfo) => {
    try {
      const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
      const margin = 15;
      let yPos = margin;
      const pageWidth = doc.internal.pageSize.width;
      const pageHeight = doc.internal.pageSize.height;

      // Utility to add footer
      function addFooter(doc, companyInfo, pageWidth, pageHeight, margin) {
        const footerY = pageHeight - 10;
        doc.setFontSize(8);
        doc.setTextColor(100);
        doc.line(margin, footerY - 3, pageWidth - margin, footerY - 3);
        doc.text(`Generated on ${new Date().toLocaleString()}`, margin, footerY);
        doc.setFont('helvetica', 'bold');
        doc.text(companyInfo.name || '', pageWidth / 2, footerY, { align: 'center' });
        doc.setFont('helvetica', 'normal');
        doc.text(companyInfo.footerText || 'Thank you for your business!', pageWidth - margin, footerY, { align: 'right' });
      }

      // HEADER
      if (logoUrl) {
        await new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            doc.addImage(img, 'PNG', margin, yPos, 40, 20);
            resolve();
          };
          img.onerror = resolve;
          img.src = logoUrl;
        });
      }

      // doc.setFontSize(10);
      // doc.setFont('helvetica', 'bold');
      // doc.setTextColor(41, 128, 185);
      // doc.text(companyInfo.name || 'Company Name', pageWidth - margin, yPos + 5, { align: 'left' });
      // doc.text(companyInfo.project || 'Project Name', pageWidth - margin, yPos + 5, { align: 'right' });

      // doc.setFont('helvetica', 'normal');
      // doc.setTextColor(100);
      // doc.text(companyInfo.registered_Office || '', doc.internal.pageSize.width - margin, yPos + 10, {
      //   align: 'right',
      //   maxWidth: 80
      // })
      // doc.text(companyInfo.registered_Office || '', pageWidth - margin, yPos + 10, { align: 'right' });
      // doc.text(`Phone: ${companyInfo.phone || ''}`, pageWidth - margin, yPos + 20, { align: 'right' });
      // doc.text(`Email: ${companyInfo.email || ''}`, pageWidth - margin, yPos + 25, { align: 'right' });

      doc.setFontSize(10);
      doc.setTextColor(41, 128, 185); // heading in blue
      doc.setFont('helvetica', 'bold');
      doc.text('Customer Name:', margin, yPos + 5);

      doc.setTextColor(0, 0, 0); // value in black
      doc.setFont('helvetica', 'normal');
      doc.text(companyInfo.name || 'N/A', margin + 32, yPos + 5); // reduced from +40 to +32

      // Project Name (Line 2)
      doc.setTextColor(41, 128, 185);
      doc.setFont('helvetica', 'bold');
      doc.text('Project Name:', margin, yPos + 10);

      doc.setTextColor(0, 0, 0);
      doc.setFont('helvetica', 'normal');
      doc.text(companyInfo.project || 'N/A', margin + 32, yPos + 10);

      yPos += 20;
      // Left side: Customer
      // doc.text(`${customerLabel} ${customerValue}`, margin, yPos + 5, { align: 'left' });

      // // Right side: Project
      // // To align heading and value together on the right, concatenate them first
      // doc.text(`${projectLabel} ${projectValue}`, pageWidth - margin, yPos + 5, { align: 'right' });

      // yPos += 35;

      // TITLE
      doc.setFontSize(18);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(0);
      doc.text('PURCHASE ORDER', pageWidth / 2, yPos, { align: 'center' });

      doc.setLineWidth(0.5);
      doc.line(margin, yPos + 5, pageWidth - margin, yPos + 5);
      yPos += 15;
      // PO Number and Date (same row)
      doc.setFontSize(11).setFont('helvetica', 'bold');
      doc.text('PO Number:', margin, yPos);
      doc.setFont('helvetica', 'normal');
      doc.text(rowData.poNumber || '', margin + 25, yPos);

      doc.setFont('helvetica', 'bold');
      doc.text('Date:', margin + 60, yPos);
      doc.setFont('helvetica', 'normal');
      doc.text(
        rowData.poDate
          ? new Date(rowData.poDate).toLocaleDateString('en-GB')
          : '',
        margin + 73,
        yPos
      );

      // // ✅ Currency on same row
      // doc.setFont('helvetica', 'bold');
      // doc.text('Currency:', margin + 110, yPos); // adjust spacing as needed
      // doc.setFont('helvetica', 'normal');
      // doc.text('INR', margin + 130, yPos);

      // yPos += 7; 
      // move to next row for payment terms

      // Payment Terms (next line)
      // doc.setFont('helvetica', 'bold');
      // doc.text('Payment Terms:', margin, yPos);
      // doc.setFont('helvetica', 'normal');
      // doc.text('45 Days from Invoice Date', margin + 35, yPos);

      // yPos += 10;

      yPos += 7;


      const maxLineWidth = 79;
      const lineHeight = 5;

      const billingLines = [
        rowData.customer?.name || '',
        ...(doc.splitTextToSize(rowData.billingAddress?.address || '', maxLineWidth)),
        ...(doc.splitTextToSize(
          `${rowData.billingAddress?.city || ''}, ${rowData.billingAddress?.state || ''} - ${rowData.billingAddress?.pincode || ''}`,
          maxLineWidth
        ))
      ];

      const shippingLines = [
        rowData.customer?.name || '',
        ...(doc.splitTextToSize(rowData.dispatchAddress?.address || '', maxLineWidth)),
        ...(doc.splitTextToSize(
          `${rowData.dispatchAddress?.city || ''}, ${rowData.dispatchAddress?.state || ''} - ${rowData.dispatchAddress?.pincode || ''}`,
          maxLineWidth
        ))
      ];

      // Calculate box height: line count + GST line + padding
      const billingBoxHeight = (billingLines.length + 1) * lineHeight + 3; // +3 for bottom space
      const shippingBoxHeight = (shippingLines.length + 1) * lineHeight + 3;

      doc.setFontSize(10);

      // Billing Box
      doc.setFont('helvetica', 'bold');
      doc.text('BILLING TO:', margin, yPos + 5);
      doc.setFont('helvetica', 'normal');
      doc.setFillColor(245, 245, 245);
      doc.rect(margin, yPos + 10, 85, billingBoxHeight, 'F');
      billingLines.forEach((line, i) => {
        doc.text(line, margin + 3, yPos + 15 + i * lineHeight);
      });
      if (rowData.customer?.gst) {
        doc.setFont('helvetica', 'bold');
        doc.text(`GST No: ${rowData.customer.gst}`, margin + 3, yPos + 15 + billingLines.length * lineHeight);
      }

      // Shipping Box
      doc.setFont('helvetica', 'bold');
      doc.text('SHIPPED TO:', margin + 95, yPos + 5);
      doc.setFont('helvetica', 'normal');
      doc.setFillColor(245, 245, 245);
      doc.rect(margin + 95, yPos + 10, 85, shippingBoxHeight, 'F');
      shippingLines.forEach((line, i) => {
        doc.text(line, margin + 98, yPos + 15 + i * lineHeight);
      });
      if (rowData.customer?.gst) {
        doc.setFont('helvetica', 'bold');
        doc.text(`GST No: ${rowData.customer.gst}`, margin + 98, yPos + 15 + shippingLines.length * lineHeight);
      }


      const boxBottom = yPos + 10 + Math.max(billingBoxHeight, shippingBoxHeight);
      yPos = boxBottom + 10;

      // ITEMS TABLE
      const columns = [
        { header: '#', dataKey: 'serialNumber' },
        { header: 'Description', dataKey: 'description' },
        { header: 'HSN', dataKey: 'hsnCode' },
        { header: 'Qty', dataKey: 'quantity' },
        { header: 'Unit', dataKey: 'uom' },
        { header: 'Rate', dataKey: 'rate' },
        { header: 'Taxable Value', dataKey: 'taxableValue' },
        { header: 'GST Amount', dataKey: 'gstValue' },
        { header: 'Total Amount', dataKey: 'totalValue' }
      ];

      const tableData = rowData.items.map((item, index) => ({
        serialNumber: index + 1,
        description: `${item.item?.name || ''}\n${item.item?.description || ''}`,
        hsnCode: item.hsnCode || '',
        quantity: item.quantity || 0,
        uom: item.uom || '',
        rate: item.rate?.toFixed(2) || '0.00',
        taxableValue: item.taxableValue?.toFixed(2) || '0.00',
        gstValue: item.gstValue?.toFixed(2) || '0.00',
        totalValue: item.totalValue?.toFixed(2) || '0.00'
      }));

      const subtotal = rowData.items.reduce((sum, item) => sum + (item.taxableValue || 0), 0);
      const taxTotal = rowData.items.reduce((sum, item) => sum + (item.gstValue || 0), 0);
      const grandTotal = subtotal + taxTotal;

      doc.autoTable({
        startY: yPos,
        head: [columns.map(c => c.header)],
        body: tableData.map(row => columns.map(col => row[col.dataKey])),
        margin: { left: margin, right: margin },
        styles: {
          fontSize: 9,
          halign: 'center',
          valign: 'middle'
        },
        columnStyles: {
          0: { cellWidth: 8 },
          1: { cellWidth: 35 },
          2: { cellWidth: 20 },
          3: { cellWidth: 12 },
          4: { cellWidth: 15 },
          5: { cellWidth: 20, halign: 'right' },
          6: { cellWidth: 25, halign: 'right' },
          7: { cellWidth: 25, halign: 'right' },
          8: { cellWidth: 25, halign: 'right' }
        },
        didDrawPage: function () {
          addFooter(doc, companyInfo, pageWidth, pageHeight, margin);
        }
      });

      yPos = doc.lastAutoTable.finalY + 10;
      const spaceNeededForTotals = 30; // estimate space needed for totals
      const footerThreshold = pageHeight - 20;

      if (yPos + spaceNeededForTotals > footerThreshold) {
        doc.addPage();
        addFooter(doc, companyInfo, pageWidth, pageHeight, margin);
        yPos = margin;
      }

      // TOTALS
      doc.setFontSize(10).setFont('helvetica', 'bold');
      doc.text('Subtotal:', pageWidth - margin - 60, yPos);
      doc.text(`${subtotal.toFixed(2)}`, pageWidth - margin, yPos, { align: 'right' });

      yPos += 7;
      doc.text('Tax (GST):', pageWidth - margin - 60, yPos);
      doc.text(`${taxTotal.toFixed(2)}`, pageWidth - margin, yPos, { align: 'right' });

      yPos += 7;
      doc.setFontSize(11);
      doc.setTextColor(220, 53, 69);
      doc.text('Grand Total:', pageWidth - margin - 60, yPos);
      doc.text(`${grandTotal.toFixed(2)}`, pageWidth - margin, yPos, { align: 'right' });
      doc.setTextColor(51, 51, 51);
      yPos += 15;

      // TERMS & CONDITIONS
      // const terms = [
      //   "1. Your Bill must specify/ref SNAP SOLUTIONS PO details, Material Part Number, Tax codes, UOM, Unit prices as per our Purchase orders only.",
      //   "2. Freight Charges - Supplier Scope.",
      //   "3. Taxes - GST as applicable extra to SNAP SOLUTIONS Account. GST Monthly Returns and GST payment to Govt is mandatory requirement to release of any payment. Copy of GST monthly returns to be submitted if demanded.",
      //   "4. Insurances - You shall cover transit insurance charges for the materials being supplied by you under this order.",
      //   "5. Warranty - The material supplied by you against this PO shall be warranted for 30 months from the date of supply or 24 months from the date of commissioning whichever is earlier.",
      //   "6. PO Validity - This PO is valid till completion of this Project.",
      //   "7. Price Validity - The pricing will be valid till such time the project is complete in all respects and there shall be no claim for escalation in price for whatsoever may be the reason.",
      //   "8. LD Clause - The materials to be supplied as per schedule given by site in-charge, failing which the penalty will be imposed accordingly. The maximum penalty will be up to 10% of total contract value.",
      //   "9. Cancellation - SNAP SOLUTIONS reserves the right to cancel the purchase order at any point of time, if the materials supplied are not up to expectations or if there is any deviation from your side.",
      //   "10. Joint Site Meet - The senior representative of the company shall periodically visit the site for a joint site meeting with site in charge (NA).",
      //   "11. Joint Measurement - The contractor shall take joint measurement with site-in charge before covering or placing beyond reach any item of work. If neglected, the item shall be uncovered at contractors expense or payment will be denied (NA).",
      //   "12. Invoice Submission - Invoices against supply of any materials within this PO must include: 1) Commercial/Tax Invoice, 2) Delivery challan (acknowledged), 3) Lorry Receipt, 4) Guarantee Certificate, 5) Warranty Certificate, 6) Packing List, 7) Inspection Report, 8) Test certificate, 9) MDCC (from Project In-charge), 10) Weighment Slip if demanded.",
      //   "13. All hard copies (originals) with 2 sets must be submitted to Project In-charge. Acknowledgement copy to be emailed.",
      //   "14. Vendor/Supplier shall be solely responsible for quality. If any deficiency is found at site during unloading/removal/installation/commissioning, it must be replaced at Vendor's cost. Any delay in project due to this is solely Vendor's responsibility.",
      //   "15. Payment follow-up and coordination to be done with Project In-charge after submission of required documents and acknowledgement.",
      //   "16. Order Acknowledgment - A signed scan copy of the order must be returned within 3 days. If not received within 7 days, the order will be considered accepted.",
      //   "17. Force Majeure - You will not be considered at fault if delivery is prevented by Force Majeure events (Act of God, War, Riots, etc.), provided written notice is given within 15 days. Same applies to SNAP SOLUTIONS.",
      //   "18. Jurisdiction - Disputes shall be settled via arbitration under Indian Arbitration Act, 1996. Venue: Chennai, Tamil Nadu. Decision of arbitrator is final.",
      //   "19. Merger & Integration - This contract is the complete agreement. Any changes must be documented and signed by all parties.",
      //   "20. Anti-Corruption (a) The Service Provider must not offer any bribe, gift, or reward to anyone working for or engaged by SNAP SOLUTIONS.",
      //   "21. Anti-Corruption (b) If any employee/agent/subcontractor breaches this, SNAP SOLUTIONS may terminate the agreement without liability. The Service Providers liability will be unlimited.",
      //   "22. Anti-Corruption (c) The Service Provider must provide a self-certificate of compliance with anti-bribery and anti-corruption laws.",
      //   "23. Supply Scope - All materials/equipment to be supplied per approved specifications/drawings. Approval from Project In-charge is required for any material changes.",
      //   "24. Supply Schedule - Supply schedule must be discussed and agreed with Project In-charge. Dispatch clearance must be obtained before shipping materials.",
      //   "25. Quantity Variation - Materials must be supplied as per site requirement within PO quantity. Any excess requires prior approval and PO amendment. Bills beyond PO quantity will not be accepted.",
      //   "26. BOQ - Bills will be paid based on actual quantity used at site and unit rates in PO/Annexure.",
      //   "27. Completion of Project - Delivery is subject to site readiness. Vendor must confirm with site in-charge before sending materials to avoid storage/handling issues."
      // ];

      // doc.setFontSize(10);
      // doc.setFont('helvetica', 'bold');
      // doc.text('Terms & Conditions:', margin, yPos);
      // doc.setFont('helvetica', 'normal');
      // yPos += 5;

      // const lineHeight = 6;

      // const maxWidth = pageWidth - margin * 2 - 10;

      // let allLines = [];
      // terms.forEach(term => {
      //   const lines = doc.splitTextToSize(term, maxWidth);
      //   allLines.push(...lines);
      // });

      // for (let i = 0; i < allLines.length; i++) {
      //   if (yPos + lineHeight > pageHeight - 15) {
      //     doc.addPage();
      //     addFooter(doc, companyInfo, pageWidth, pageHeight, margin);

      //     // 🔁 Re-apply styles after page break
      //     doc.setFont('helvetica', 'normal');
      //     doc.setFontSize(10);
      //     doc.setTextColor(51, 51, 51);

      //     yPos = margin;

      //     // Optionally re-print "Terms & Conditions" heading on new page
      //     doc.setFont('helvetica', 'bold');
      //     doc.text('Terms & Conditions (contd.):', margin, yPos);
      //     yPos += 6;
      //     doc.setFont('helvetica', 'normal');
      //   }

      //   doc.text(allLines[i], margin + 5, yPos);
      //   yPos += lineHeight;
      // }

      // Save the final PDF
      doc.save(`PO_${rowData.poNumber}.pdf`);
    } catch (err) {
      console.error('Error generating PDF:', err);
      const doc = new jsPDF();
      doc.text('Error generating PDF', 10, 10);
      doc.text(err.message, 10, 20);
      doc.save('error.pdf');
    }
  }
};

export default PurchaseOrderPDF;
